export default __webpack_public_path__ + "static/media/internYellow.329ac2a8.svg";